import { useVatModeStore } from '@/stores/vatModeStore';

// Shared VAT display switch for every financial report (Excl. VAT default).
export function VatModeToggle({ className = '' }) {
  const inclVat = useVatModeStore((s) => s.inclVat);
  const setInclVat = useVatModeStore((s) => s.setInclVat);
  const btn = (on, label, id) => (
    <button type="button" onClick={() => setInclVat(on)} data-testid={id}
      className={`px-2.5 py-1 rounded-md text-xs font-medium transition-colors ${inclVat === on ? 'bg-white shadow text-foreground' : 'text-muted-foreground hover:text-foreground'}`}>
      {label}
    </button>
  );
  return (
    <div className={`inline-flex items-center bg-muted rounded-lg p-0.5 ${className}`} title="Display only — accounting profit, GL and VAT returns are not affected" data-testid="vat-mode-toggle">
      {btn(false, 'Excl. VAT', 'vat-mode-excl')}
      {btn(true, 'Incl. VAT', 'vat-mode-incl')}
    </div>
  );
}
